import { Link } from 'react-router-dom';
import { articles, featuredArticles } from '@/mocks/data';

export default function HomeHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://piccraft.github.io/api/search-image?query=Artistic%20photography%20studio%20scene%20with%20camera%20and%20soft%20natural%20light%2C%20warm%20cream%20and%20beige%20tones%2C%20minimalist%20elegant%20composition%2C%20editorial%20photography%20aesthetic%2C%20abstract%20geometric%20shapes%2C%20soft%20shadows%2C%20clean%20sophisticated%20background&width=1800&height=900&seq=home-hero-bg&orientation=landscape"
          alt="摄影教程封面"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading mb-4 leading-tight">
          自拍偷拍技巧大全
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          掌握构图技巧、设备推荐、角度选择与后期处理方法，拍出自然真实、充满情感的人像作品
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/candid-capture"
            className="px-6 py-3 bg-primary-500 text-white rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            开始学习
          </Link>
          <Link
            to="/category/self-portrait-composition"
            className="px-6 py-3 bg-white/15 text-white backdrop-blur-sm rounded-lg font-medium text-sm hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览教程
          </Link>
        </div>
      </div>
    </section>
  );
}

export function HomeFeatured() {
  const featured = articles.filter((a) => featuredArticles.includes(a.id));

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
          精选教程
        </h2>
        <p className="text-foreground-600 text-sm max-w-xl mx-auto">
          精心挑选的最受欢迎教程，帮助你快速掌握自拍与抓拍的核心技巧
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {featured.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
          >
            <div className="aspect-[16/9] overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full font-medium">
                  {article.tags[0]}
                </span>
                <span>{article.readTime} 分钟阅读</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 font-heading mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {article.excerpt}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}